import './serviceNowAds.scss';
import './../../src-utilities/footer';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import '../../src-utilities/ourOffering';
import './../../src-utilities/getInTouch';
import '../../src-utilities/industries';
import './../../src-utilities/country';
import testimonial from '../../src-utilities/testimonial';
import JustValidate from '.././../../node_modules/just-validate';

var swiper = new Swiper('.swiper-container', {
	modules: [Pagination, Autoplay],
	pagination: {
		el: '.swiper-container .swiper-pagination',
	},
	autoplay: {
		delay: 2500,
		disableOnInteraction: false,
	},
});
gsap.matchMedia().add('(min-width:1050px)', () => {
	gsap.timeline({
		onStart: () => {
			document.querySelector(
				'.hero-section .consultation_button',
			).style.background = 'var(--hero-btn-background)';
			document.querySelector(
				'.hero-section .consultation_button',
			).style.color = 'var(--btn-text)';
		},
		onReverseComplete: () => {
			document.querySelector(
				'.hero-section .consultation_button',
			).style.background = 'transparent';
			document.querySelector(
				'.hero-section .consultation_button',
			).style.color = 'var(--heading-color)';
		},

		scrollTrigger: {
			trigger: '.hero-section',
			scrub: true,
			pinSpacing: false,
			start: '20% 20%',
			end: () => document.querySelector('.hero-image').clientHeight,
		},
	})
		.to('.hero-section .container', {
			yPercent: 100,
		})
		.to(
			'.hero-section .hero-image',
			{
				opacity: 0.2,
			},
			0,
		);
});

const BindEvent = () => {
	let faq_question = document.getElementsByClassName('faq-question');
	let hiddenFaqs = document.querySelectorAll('.hidden-faq');

	for (let i = 0; i < faq_question.length; i++) {
		const question = faq_question[i];
		question.addEventListener('click', function (e) {
			let all_faq = document.getElementsByClassName('faq');
			let isopen =
				e.currentTarget.parentNode.classList.contains('active');
			for (let index = 0; index < all_faq.length; index++) {
				all_faq[index].classList.remove('active');
			}
			if (isopen == false) {
				e.currentTarget.parentNode.classList.add('active');
			}
		});
	}
};
BindEvent();

// Testimonial
testimonial();

// our customer
new Swiper('.customers-logo', {
	modules: [Autoplay],
	slidesPerView: 6,
	loop: true,
	autoplay: {
		delay: 10,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	speed: 2000,
	breakpoints: {
		0: {
			spaceBetween: 15,
			slidesPerView: 3,
		},
		600: {
			slidesPerView: 5,
			spaceBetween: 30,
		},
	},
});

window.addEventListener('resize', function () {
	ScrollTrigger.refresh();
});

function RightChoice() {
	let isStatsVisilble = false;
	const target = document.querySelector('.cyntexa-right-choice-cont');

	function handleIntersection(entries) {
		entries.map((entry) => {
			if (entry.isIntersecting) {
				if (!isStatsVisilble) {
					isStatsVisilble = true;
					document
						.querySelectorAll('.statis')
						.forEach(function (element) {
							var countTo = parseInt(
								element.getAttribute('data-stats'),
							);
							var countNum = parseInt(element.textContent);

							var duration = 3000;
							var startTime = null;

							function animate(timestamp) {
								if (!startTime) startTime = timestamp;
								var progress = timestamp - startTime;
								var increment = (countTo / duration) * progress;

								if (progress < duration) {
									element.textContent = Math.floor(
										countNum + increment,
									);
									requestAnimationFrame(animate);
								} else {
									element.textContent = countTo;
								}
							}

							requestAnimationFrame(animate);
						});
				}
			}
		});
	}

	const observer = new IntersectionObserver(handleIntersection);

	observer.observe(target);
}
RightChoice();
gsap.registerPlugin(ScrollTrigger);

const validate = new JustValidate('#servicenowads');

validate
	.addField('#lfirstname', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
		{
			rule: 'customRegexp',
			value: /^([a-zA-Z0-9]+|[a-zA-Z0-9]+\s{1}[a-zA-Z0-9]{1,}|[a-zA-Z0-9]+\s{1}[a-zA-Z0-9]{3,}\s{1}[a-zA-Z0-9]{1,})$/g,
			errorMessage: 'Enter Valid Full Name',
		},
	])
	.addField('#lemail', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	])
	.addField('#lphone', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 4,
		},
		{
			rule: 'maxLength',
			value: 15,
		},
		{
			rule: 'number',
		},
	])
	.addField('#country-phone-code', [
		{
			rule: 'required',
		},
	])
	.addField('#Message', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
	]);

let sendURL =
	'https://script.google.com/macros/s/AKfycbx8ayXA3A_tI73OVHHrFcIUhImDnsAglBUFO_SLGPAoUI2N50AuOIRnkgNWqLwlWs0d/exec';

let GoogleSendURL =
	'https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec';

var loading_global = document.querySelector('.loading-div');

document.querySelector('#servicenowads').addEventListener('submit', (event) => {
	if (validate.isValid == false) {
		return false;
	}

	event.preventDefault();

	document.querySelector('.loading-div').classList.add('active');

	const form = document.getElementById('servicenowads');
	const formData = new FormData(form);

	let fullName = formData.get('lfirstname').split(' ');
	let firstName, lastName;
	[firstName, ...lastName] = fullName;
	lastName = lastName.join(' ');
	let phoneNumber = formData.get('lphone');
	let phoneCode = formData.get('phonecode');
	let url = new URL(window.location.href);
	url = String(url.pathname);
	formData.append('lsource', 'Website Form - Talk to Consultant');
	url = url.replace('/', '').replace('/', '');
	formData.set('lfirstname', firstName);
	formData.set('llastname', lastName);

	formData.set('lphone', phoneCode + ' ' + phoneNumber);
	formData.append('sendurlvalue', window.location.href);

	var url1 = window.location.href;

	let request = '?';
	[...formData].forEach(([key, value], index) => {
		request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
	});

	const requestOptions = {
		method: 'GET',
		redirect: 'follow',
	};

	fetch(sendURL + request, requestOptions)
		.then((response) => response.text())
		.then((result) => {
			fetch(GoogleSendURL + request, requestOptions)
				.then((response) => response.text())
				.then((result) => {
					window.location.href =
						'https://cyntexa.com/success?type=servicenow-services&emailid=' +
						formData.get('lemail') +
						'';
					$zoho.salesiq.visitor.uniqueid();
					$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
					$zoho.salesiq.visitor.email(formData.get('lemail'));
				})
				.catch((error) => console.error(error));
		})
		.catch((error) => console.error(error));
});
